'use client'

import { useLanguage } from '@/i18n/LanguageProvider'

export default function BridgePage() {
  const { t } = useLanguage()

  return (
    <main className="min-h-screen bg-gradient-to-b from-[#1C1C1C] to-[#252525] text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bauhaus mb-8 text-[#B9AE9A]">
            {t('gravilens.bridge.title')}
          </h1>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-lg mb-12">
              {t('gravilens.bridge.description')}
            </p>

            <h2 className="text-2xl font-bauhaus mb-6 text-[#B9AE9A]">
              {t('gravilens.bridge.features.title')}
            </h2>

            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 rounded-full bg-[#B9AE9A] mt-2"></div>
                <div>
                  <h3 className="text-xl font-bauhaus mb-4 text-[#B9AE9A]">
                    {t('gravilens.bridge.features.workshop')}
                  </h3>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 rounded-full bg-[#B9AE9A] mt-2"></div>
                <div>
                  <h3 className="text-xl font-bauhaus mb-4 text-[#B9AE9A]">
                    {t('gravilens.bridge.features.reading')}
                  </h3>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 rounded-full bg-[#B9AE9A] mt-2"></div>
                <div>
                  <h3 className="text-xl font-bauhaus mb-4 text-[#B9AE9A]">
                    {t('gravilens.bridge.features.publishing')}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
} 